"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./CampaignItem.scss");

require("./CampaignItemDark.scss");

var _reactstrap = require("reactstrap");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var INBOUND_TYPES_ICONS = {
  5: 'whatsapp-defcol',
  6: 'preview'
};

var CampaignItem = function CampaignItem(props) {
  var onPin = function onPin(e) {
    e.stopPropagation();
    props.onPin(!props.pin);
  };

  var onActive = function onActive() {
    props.onActive(!props.active);
  };

  var onLoad = function onLoad(e) {
    e.stopPropagation();
    props.onLoad();
  };

  var onCancel = function onCancel(e) {
    e.stopPropagation();
    props.onCancel();
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-campitem ".concat(props.active && 'active'),
    onClick: onActive
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-body ".concat(props.pin ? 'pin' : 'noPin', " ").concat(props.showLoadBtn ? 'load' : 'noLoad')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-line ".concat(props.campaignType)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-dot ".concat(props.powerOn)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-icon ".concat(props.campaignType)
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + props.iconSrc
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-name"
  }, /*#__PURE__*/_react["default"].createElement("span", null, props.label), props.showMessage && /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-message"
  }, /*#__PURE__*/_react["default"].createElement("span", null, props.message)), props.showProgress && /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-progress"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon close-circle",
    onClick: onCancel
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.Progress, {
    color: 'secondary',
    striped: true,
    value: props.progress
  })), !props.showMessage && !props.showProgress && props.inboundType != null && INBOUND_TYPES_ICONS[props.inboundType] && /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-inbound"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(INBOUND_TYPES_ICONS[props.inboundType])
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-pin ".concat(props.pin ? 'pin' : 'noPin', " ")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onPin
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon pin"
  }))), props.showLoadBtn && props.campaignType === 'outbound' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "glc-campitem-load",
    onClick: onLoad
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon sc"
  })));
};

CampaignItem.propTypes = {
  active: _propTypes["default"].bool,
  campaignType: _propTypes["default"].oneOf(['outbound', 'inbound']),
  powerOn: _propTypes["default"].bool,
  pin: _propTypes["default"].bool,
  label: _propTypes["default"].string.isRequired,
  message: _propTypes["default"].string,
  showMessage: _propTypes["default"].bool,
  showProgress: _propTypes["default"].bool,
  progress: _propTypes["default"].number,
  onActive: _propTypes["default"].func.isRequired,
  onPin: _propTypes["default"].func.isRequired,
  iconSrc: _propTypes["default"].string.isRequired,
  showLoadBtn: _propTypes["default"].bool,
  onCancel: _propTypes["default"].func.isRequired,
  onLoad: _propTypes["default"].func.isRequired,
  inboundType: _propTypes["default"].number
};
CampaignItem.defaultProps = {
  active: false,
  campaignType: 'inbound',
  powerOn: false,
  pin: false,
  label: '',
  onActive: function onActive() {},
  onPin: function onPin() {},
  iconSrc: '',
  message: '',
  showMessage: false,
  showProgress: false,
  progress: 0,
  showLoadBtn: false,
  onCancel: function onCancel() {},
  onLoad: function onLoad() {}
};
var _default = CampaignItem;
exports["default"] = _default;